const he = {
    appName: 'ריקוד ישראלי',
    dir: 'rtl',
    general: {
        invalid_password: 'סיסמה חייבת להיות בת 8 תוים לפחות',
        invalid_verify_password: 'הסיסמה לא תואמת את שדה הסיסמה הראשון',
        loading: 'בטעינה...',
    },
    main: {
        title: 'הריקודים האחרונים:',
        searchTitle: 'תוצאות חיפוש:',
        myAccount: 'החשבון שלי',
        logout: 'התנתק',
        loading: 'טוען את הריקודים החדשים ביותר',
        login: 'התחבר',
    },
    dance: {
        supportedMediaTypes: 'סוגי המדיה הנתמכים: ',
        mediaAddedSuccessfully: 'המדיה נוספה בהצלחה',
        name: 'שם המדיה',
        lyricists: 'משורר',
        composers: 'מלחין',
        mediaUrl: 'קישור למדיה',
        selectedMedia: 'המדיה שנבחרה:',
        uploadMedia: 'העלאת מדיה',
        videos: 'סרטונים',
        audio: 'מנגינה',
        WaitingForChoreographerApproval: 'ממתין לאישור היוצר',
        song: 'שיר',
        video: 'סרטון',
        addMedia: 'הוסף מדיה',
        addMediaForLoggedUsers: 'הוסף מדיה (משתמשים מחוברים בלבד)',
        rokdimLink: 'לדף הריקוד באתר רוקדים',
        add: 'הוסף',
        cancel: 'ביטול',
        addLinkMedia: 'הוספת קישור למדיה',
        addFileMedia: 'הוספת קובץ מדיה',
        danceStyle: 'סגנון הריקוד - ',
        uploadDate: 'תאריך העלאה - ',
        creationDate: 'שנת יצירה: ',
        numOfDownloads: 'מספר הורדות:',
        numOfViews: 'מספר צפיות:',
        extraInfo: 'למידע נוסף',
        extraInfoTooltip: 'לדף הריקוד',
        downloadTooltip: 'להורדה',
        likeTooltip: 'אהבתי',
        shareTooltip: 'שיתוף',
        deleteTooltip: 'מחק',
        description: 'תיאור',
        composer: 'מלחין',
        choreographer: 'יוצר',
        choreographers: 'יוצרים',
        lyricist: 'משורר',
        manageRequest: '{{num}} בקשות ממתינות לאישור',
        unavailable: 'לא זמין',
        notFound: 'פרטי הריקוד אינם זמינים כרגע...',
        noMedia: 'עדיין אין מדיה לריקוד זה',
        styles: {
            circle: 'מעגל',
            couples: 'זוגות',
            couplesSwap: 'זוגות מתחלפים',
            couplesLines: 'זוגות שורות',
            lines: 'שורות',
            kidsLines: 'ילדים-שורות',
            kids: 'ילדים',
            kidsCircle: 'ילדים-מעגל',
            kidsCouples: 'ילדים-זוגות',
            threeWay: 'שלישייה',
            fourWay: 'רבייעיה',
        },
        tags: {
            lable: 'בחר תגיות:',
            dance: 'ריקוד',
            learn: 'לימוד',
            both: 'ריקוד + לימוד',
        },
        songDetails: 'פרטי השיר:',
        videoList: 'רשימת סרטונים:',
        songsList: 'רשימת מנגינות:',
    },
    newMedia: {
        video: 'וידאו',
        song: 'מנגינה',
        VIDEO: 'וידאו',
        SONG: 'מנגינה',
        noMedia: 'עוד אין מדיה.',
        songUpload: 'העלאת קובץ מנגינה :',
        videoUpload: 'הוספת קישור ליוטיוב :',
        upload: 'העלאה:',
        submit: 'הוסף {{mediaType}}',
        fileStatusSuccess: 'הקובץ עלה בהצלחה',
        fileStatusError: 'העלאת הסרטון נכשלה, אנה נסה שוב',
        error: 'הסרטון כבר קיים, נא הכנס קישור לסרטון חדש.',
        warning: 'אזהרה:',
        invalidType: 'סוג המדיה שנבחר אינו תקין',
        clickToAdd: 'לחץ כאן להעלאת {{mediaType}}',
        add: 'העלאת {{mediaType}}',
        missingTag: 'יש לסמן תגית אחת לפחות',
        selectAudio: 'בחר קובץ...',
        description: ' תיאור:',
        label: 'בחר תגיות:',
    },
    myDances: {
        title: 'הריקודים שלי',
        mediaForDelete: 'בקשות למחיקה',
        mediaForUpload: 'בקשות להעלאה',
        noDances: 'עדיין אין לך ריקודים...',
        loading: 'מאתר את הריקודים שלך',
    },
    search: {
        input: 'מצא ריקוד...',
        pagination: 'מספר שרים לדף :',
        filtered: 'מצא ריקוד לפי...',
        advanced: 'חיפוש מתקדם',
        search: 'חפש',
        results: 'התוצאות הקרובות ביותר',
        next: 'לעמוד הבא',
        previous: 'לעמוד הקודם',
        noOptions: 'אין השלמות',
        noResults: 'לא נמצאו תוצאות מתאימות...',
        filterByStyle: 'סנן לפי סוג הריקוד: ',
        filters: {
            name: 'שם הריקוד',
            style: 'סגנון',
            creators: 'שם היוצר/ים',
            firstName: 'שם פרטי של היוצר',
            lastName: 'שם משפחה של היוצר',
            performer: 'מבצע',
            composer: 'מלחין',
            artist: 'מבצע / משורר / מלחין',
            lyricist: 'משורר',
            choreographer: 'כוריאוגרף',
            danceMediasIcons: 'מדיה',
            creationDate: 'שנת יצירה',
        },
        styles: {
            lines: 'שורות',
            trio: 'שלשות',
            pair: 'זוגות',
            circles: 'מעגלים',
            changeablePairs: 'זוגות מתחלפים',
            childrens: 'ילדים',
            childrensParis: 'ילדים זוגות',
            childrensCircles: 'ילדים מעגלים',
            childrensLines: 'ילדים שורות',
        },
    },
    welcome: {
        continue: 'המשך',
        password: 'סיסמה',
        passwordRequired: 'יש להכניס סיסמה',
        confirmPassword: 'אישור סיסמה',
        forgotPassword: 'שכחת את הסיסמה?',
        resetPassword: 'איפוס סיסמה',
        noMatch: 'אין התאמה בין הסיסמאות',
        resetEmail: 'שלח מייל לאיפוס סיסמה',
        alreadyRegistered: 'כבר רשום?',
        login: 'להתחברות',
        logout: 'התנתק',
        signIn: 'התחבר',
        register: 'להרשמה',
        email: 'כתובת מייל',
        invalidEmail: 'יש להכניס כתובת מייל תקינה',
        welcome: 'ברוכים הבאים לריקוד ישראלי',
        rememberMe: 'זכור אותי',
        newUser: 'משתמש חדש ?',
        invalidInput: 'נדרש להזין {{input}} תקינ/ה.',
        fullName: 'שם מלא',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        appName: 'ריקוד ישראלי',
        attention:
            'לתשומת לבך, במידה והנך כוריאוגרפ/ית, על מנת לקבל גישה למערכת ניהול הריקודים שלך, יש להירשם באמצעות כתובת המייל המוזנת באתר מרקיד',
        markidName: 'שם משתמש באתר מרקיד',
        isRegisteredInMarkid: 'יש לי משתמש באתר מרקיד',
    },
    menu: {
        Home: 'דף הבית',
        MyDances: 'הריקודים שלי',
        Search: 'חיפוש מתקדם',
        MyRequests: 'ניהול בקשות',
    },
    user: {
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        email: 'אימייל:',
        userDescription: 'פרטים נוספים:',
        editButton: 'עדכון פרטים',
        backButton: 'חזור',
        saveButton: 'שמור',
        requests: {
            upload: 'בקשה להעלאת ה{{mediaType}}: ',
            delete: 'בקשה למחיקת ה{{mediaType}}: ',
            song: 'מנגינה',
            video: 'סרטון',
            pending: 'הבקשה ממתינה לאישורך',
            toDance: 'לריקוד - ',
            title: 'בקשות הממתינות לאישורך',
            danceName: 'שם הריקוד - {{name}} ',
            loading: 'מרכז את כל הבקשות',
            noRequests: 'כל הריקודים שלך מאושרים!',
        },
    },
    profile: {
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        email: 'אימייל:',
        save: 'שמור שינויים',
        cancel: 'ביטול',
        upload: 'בחר תמונת פרופיל',
        changesSaved: 'השינויים נשמרו בהצלחה',
    },
    advancedSearch: {
        search: 'חיפוש',
        name: 'שם',
        style: 'סגנון',
        choreographers: 'יוצרים',
        performer: 'מבצע',
        danceName: 'שם הריקוד',
        choreographer: 'יוצר',
        lyricistOrComposer: 'משורר / מלחין',
        filterByStyle: 'סנן לפי סגנון',
        composers: 'מלחינים',
        lyricists: 'משוררים',
        mediaForApproval: 'מספר מדיה לאישור',
    },
    unlockContent: {
        header: 'תוכן זה מחייב התחברות למערכת',
        p1: 'על מנת להשתמש בכל האפשריות הקיימות במערכת עליך להתחבר לחשבון שלך',
        p2: 'כניסה למערכת תאפשר לך לצפות בריקודים שלך, להעלות מדיה, לבצע חיפוש מתקדם לריקודים ועוד',
        loginOrRegister: 'לחץ כאן לכניסה / הרשמה',
    },
    toolbar: {
        signInSignUp: 'התחברות / הרשמה',
        linkedChoreographer: 'מרקיד',
    },
    allMediaRequests: {
        allMediaRequests: 'כל בקשות המדיה',
        name: 'יוצר',
        mediaRequests: 'בקשות מדיה',
    },
}

export default he
